<template>
  <div :class="items.length > 0 ? '':'hidden'" ref="scrolledContainer" id="scrolled-container" class="top-0 flex flex-col relative">
    <div class="absolute trigger-container top-0 left-0 z-50 w-full invisible touch-none pointer-events-none	">
      <div class="h-[40vh] flex items-center justify-center bg-gray-600 bg-opacity-50 border-b border-black"></div>
      <div class="scroll-trigger-group">
        <div v-for="(item, i) in items.length" :key="i" class="h-[100vh] flex items-center justify-center bg-gray-600 bg-opacity-50 border-b border-black" :class="`trigger-item-${i}`">{{ i }}</div>
      </div>
      <div class="h-[40vh] flex items-center justify-center bg-gray-600 bg-opacity-50 border-b border-black"></div>
    </div>
    <section ref="stickyContent" class="h-screen overflow-hidden">
      <div class="fixed bottom-0 h-[4px] w-full z-10">
        <div ref="lenisProgress" class="transition-all ease-out duration-500 bg-[#AEEDEA] h-full w-0 drop-shadow-lg"></div>
      </div>
        <div>
    <div ref="slider" class="bg-white md:bg-[#313187] md:flex md:min-h-screen">
      <div class="md:w-1/2 md:hidden rounded-tl-[3rem] overflow-hidden relative">
        <figure class="w-full h-full bg-gray-100 aspect-video">
          <img src="/images/home/client/client-1.webp" alt="" class="w-full h-full object-cover">
        </figure>
        <div class="absolute right-3 bottom-3 flex gap-2 bg-gray-600 bg-opacity-75 backdrop-blur px-3 py-2 rounded-full">
          <div v-for="(item, i) in items" :key="i" :class="{'active': currentIndex === i}" class="pag-dot"></div>
        </div>
      </div>
      <div class="md:w-1/2 bg-[#313187] pl-[3%] pt-[7%] pb-[7%] pr-[3%] text-white relative">
        <svg class="absolute bottom-3 right-3 md:bottom-12 md:left-6 w-[6vw] md:w-[6vw]" viewBox="0 0 102 97" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 49.035V96.3078H50.697V1.15625H101V49.035H1Z" stroke="#8AB9B7" stroke-opacity="0.5" stroke-width="1.21212"/>
        </svg>
        <div class="flex gap-12">
          <div>
            <div class="space-y-[1.6vw] transition-group h-[24vw] pt-6">
              <transition name="slide-up" mode="out-in">
                <div :key="items[currentIndex]">
                  <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-[#AEEDEA] text-[#313187] px-2 py-1 rounded mb-1 inline-block">Our Client</div>
                  <div v-if="items[currentIndex]" class="text-[24px] leading-[48px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree">{{ items[currentIndex].title[lang] }}</div>
                </div>
              </transition>
              <transition name="slide-up" mode="out-in" appear>
                <div :key="items[currentIndex]" class="text-[16px] leading-[32px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.2vw] lg:leading-[1.8vw] font-bold figtree">
                  <span v-if="items[currentIndex]">{{ items[currentIndex].subtitle[lang] }}</span>
                </div>
              </transition>
              <transition name="slide-up" mode="out-in" appear>
                <div :key="items[currentIndex]">
                  <div v-if="items[currentIndex]" class="text-[14px] leading-[24px] md:text-[1.4vw] md:leading-[2vw] lg:text-[1.1vw] lg:leading-[1.5vw] figtree" v-html="items[currentIndex].description[lang]"></div>
                  <div class="mt-8">
                    <button @click="toggleContactModal" class="hover:opacity-75 flex gap-2 items-center rounded-full text-lg md:text-[1.4vw] lg:text-[1.1vw] font-bold figtree text-[#AEEDEA] underline">
                      <span class="bg-[#AEEDEA] rounded-full w-6 h-6 flex items-center justify-center">
                        <svg class="w-5 md:w-[1.6vw] lg:w-[1.4vw] text-primary" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_605_294)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4683 5.05139C5.4683 4.4991 5.91601 4.05139 6.4683 4.05139L14.9536 4.05139C15.5059 4.05139 15.9536 4.4991 15.9536 5.05139L15.9536 13.5367C15.9536 14.089 15.5059 14.5367 14.9536 14.5367C14.4013 14.5367 13.9536 14.089 13.9536 13.5367L13.9536 7.4656L5.76119 15.658C5.37066 16.0485 4.7375 16.0485 4.34697 15.658C3.95645 15.2675 3.95645 14.6343 4.34697 14.2438L12.5394 6.05139L6.4683 6.05139C5.91601 6.05139 5.4683 5.60367 5.4683 5.05139Z" fill="currentColor"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_605_294">
                              <rect width="20" height="20" fill="white" transform="translate(20) rotate(90)"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      Contact Us
                    </button>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="flex flex-col items-center justify-center h-[70vh]">
            <div class="hidden md:flex gap-4 items-center mt-6 relative">
              <div class="w-[10vw] relative">
                <div class="absolute w-[1px] h-full left-[5px] top-0 block bg-[#6C6CC8]">
                  <div ref="timer" class="bg-[#AEEDEA]"></div>
                </div>
                <div v-for="(item, i) in items" :key="i" @click="showCardNav(i);" :class="[{'active': currentIndex === i && !ctaActive}, {'mb-[5vw]': i !== items.length - 1}]" class="vert-slider-pag w-[10px] h-[10px] rounded-full block flex items-center justify-center relative cursor-pointer">
                  <div v-if="!item.type && item.type !=='cta'" class="pag-outer">
                    <div class="pag-inner"></div>
                  </div>
                  <div v-else :class="{'active': ctaActive}" class="pag-outer">
                    <div :class="{'active': ctaActive}" class="pag-inner"></div>
                  </div>
                  <div v-if="!item.type && item.type !=='cta'" class="absolute left-6 text-[16px] leading-[20px] text-[#6C6CC8] w-[9vw] pag-title transition-all">{{ item.title[lang] }}</div>
                  <NuxtLink :href="item.target" v-else :class="{'text-[#AEEDEA]': ctaActive}" class="cta absolute left-6 text-[16px] leading-[20px] text-[#6C6CC8] w-[9vw] pag-title transition-all underline hover:text-[#AEEDEA]">See More</NuxtLink>
                </div>
              </div>
            </div>
            <div class="mt-12">
              <!-- <a class="cursor-pointer text-[#AEEDEA] underline hover:opacity-75">See More</a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="hidden md:block md:w-1/2 rounded-tl-[3rem] overflow-hidden">
        <figure class="w-full h-full bg-[#312F75] aspect-square transition-group">
          <transition name="slide-down" mode="out-in" appear>
            <img v-if="items[currentIndex]" :key="items[currentIndex]" :src="config.public.cdnUrl+config.public.cdnFolder+items[currentIndex].img_src" alt="" class="w-full h-full object-cover">
          </transition>
        </figure>
      </div>
    </div>

        </div>
    </section>
  </div>
  <div ref="stickyEnd" class="absolute w-full h-full pointer-events-none touch-none"></div>
</template>

<script setup>
import { useSwipe, useElementVisibility, useWindowScroll } from '@vueuse/core';
 
 
const lang = ref('id')
const props = defineProps(['scrollPos', 'scrollDirection', 'ready', 'items']);
const emit = defineEmits(['scrollTo']);
const stickyContent = ref();
const scrolledContainer = ref();
const stickyEnd = ref();
const scrollEnd = ref(useElementVisibility(stickyEnd));
const currentIndex = ref(0);
const interval = ref(null);
const time = ref(5000);
const height = ref(0);
const timer = ref();
const lenisProgress = ref();
let animationFrameId = null;
const startTime = ref(null);
const slider = ref();
const { x, y } = useWindowScroll({ behavior: 'smooth' });
 
const config = useRuntimeConfig();

const autoStart = () => {
  interval.value = setInterval(() => {
    currentIndex.value++;
    if (currentIndex.value >= props.items.length) {
      currentIndex.value = 0;
      height.value = 0; // Reset height to 0 for the next item
      if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
      startProgress();
    }
  }, time.value);
};

const pause = () => {
  height.value = (100 / (props.items.length - 1)) * currentIndex.value;
  if (height.value >= 100) height.value = 100;
  timer.value.style.height = height.value + '%';
  if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
  height.value = 0;
};

const startProgress = () => {
  const duration = time.value * (props.items.length - 1); // Duration in milliseconds
  const timeStart = startTime.value ? startTime.value : performance.now(); // Get the start time
  const endHeight = 100; // Target height
  const initialHeight = 0; // Initial height value

  const updateHeight = (currentTime) => {
    const elapsedTime = currentTime - timeStart; // Calculate elapsed time
    const progress = Math.min(elapsedTime / duration, 1); // Calculate progress (0 to 1)

    // Calculate the new height value based on the progress
    height.value = initialHeight + (endHeight - initialHeight) * progress;
    timer.value.style.height = height.value + '%';
    if (progress < 1) {
      // If the progress is less than 1, request the next animation frame
      animationFrameId = requestAnimationFrame(updateHeight);
    }
  };

  // Start the animation
  animationFrameId = requestAnimationFrame(updateHeight);
};

const showCardNav = (index) => {
  emit('scrollTo', '.trigger-item-' + index);
};

const scrollToSlide = (index) => {
  currentIndex.value = index;
};

const ctaActive = ref(false);
const scrollToCta = () => {
  ctaActive.value = true;
};

const nextSlide = () => {
  pause();
  if (currentIndex.value < props.items.length - 1) {
    currentIndex.value++;
  }
};
const prevSlide = () => {
  pause();
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
};

const { direction, isSwiping, lengthX, lengthY } = useSwipe(slider, {
  onSwipeEnd: (e, direction) => {
    if (direction === 'LEFT') nextSlide();
    if (direction === 'RIGHT') prevSlide();
  },
});

const stickyPos = ref(0);
const bodyLength = ref(0);

onBeforeUnmount(() => {
  if (interval.value) {
    clearInterval(interval.value);
  }
});
const containerOnViewport = ref(false);

watch(() => props.scrollPos, (val) => {
  const rect = scrolledContainer.value.getBoundingClientRect();
  if (containerOnViewport.value && rect.top <= 0) {
    stickyContent.value.style.translate = 'none';
    if (!scrollEnd.value) {
      stickyContent.value.style.transform = `translate3d(0,${Math.abs(rect.top)}px, 0)`;
    }
  } else {
    stickyContent.value.style.translate = 'none';
    stickyContent.value.style.transform = 'translate3d(0,0,0)';
  }
});

onMounted(() => {
  currentIndex.value = 0;
  bodyLength.value = document.querySelector('#__nuxt').getBoundingClientRect().height;
  scrolledContainer.value.style.height = document.querySelector('.trigger-container').clientHeight + 'px';
  nextTick(() => {
    startObserver();
  });
});

const startObserver = () => {
  const observers = [];
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0],
  };
  props.items.forEach((item, index) => {
    const el = document.querySelector('.trigger-item-' + index);
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          calculateScrollPercentage();
          if (index !== 0 && entry.intersectionRatio > 0.95) {
            if (index !== (props.items.length - 1)) {
              scrollToSlide(index);
              ctaActive.value = false;
            } else {
              scrollToCta();
            }
          }
          if (index === 0 && entry.intersectionRatio > 0.95) {
            scrollToSlide(0);
          }
        }
      });
    };
    observers[index] = new IntersectionObserver(callback, options);
    observers[index].observe(el);

    const container = document.querySelector('#scrolled-container');
    const containerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          containerOnViewport.value = true;
          stickyPos.value = stickyContent.value.getBoundingClientRect().top - window.innerHeight;
        }
      });
    };
    const containerObserver = new IntersectionObserver(containerCallback, options);
    containerObserver.observe(container);
  });
};

const calculateScrollPercentage = () => {
  const element = document.querySelector('.scroll-trigger-group');
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight;
  const elementTop = rect.top;
  const elementHeight = rect.height;
  let progress = Math.abs((elementTop / (elementHeight - windowHeight)) * 100);
  if (elementTop < 0) {
    if (progress <= 0) {
      progress = 0;
    } else if (progress >= 100) {
      progress = 100;
    }
    timer.value.style.height = progress + '%';
    lenisProgress.value.style.width = progress + '%';
  }
};

const navbarStore = useNavbarStore();
const toggleContactModal = () => {
  navbarStore.toggleContact();
};
</script>

<style lang="scss" scoped>
  .vert-slider-pag{
    @apply relative text-[#6C6CC8];
    // transition: all ease 100ms;
    .pag-outer {
      @apply w-[10px] h-[10px] rounded-full flex items-center justify-center bg-[#313187] relative;
    }
    .pag-inner {
      @apply w-[6px] h-[6px] rounded-full block bg-[#6C6CC8];
    }
    .pag-progress {
      @apply absolute w-[1px] h-[calc(5vw+10px)] top-0 left-[5px] z-0;
      .pag-progress-inner {
        @apply bg-[#AEEDEA];
      }
    }
    &.active {
      .pag-title {
        @apply text-[#AEEDEA];
      }
      .pag-outer {
        animation: bounce 450ms;
        animation-timing-function: linear;
        @apply border;
      }
      .pag-inner {
        @apply bg-[#AEEDEA] scale-100 w-[4px] h-[4px];
      }
    }
    .pag-outer.active {
      animation: bounce 450ms;
      animation-timing-function: linear;
      @apply border;
    }
    .pag-inner.active {
      @apply bg-[#AEEDEA] scale-100 w-[4px] h-[4px];
    }
  }

  .pag-dot {
    @apply w-1 h-1 bg-white bg-opacity-50 rounded-full transition-all duration-500;
    &.active {
      @apply bg-opacity-100 w-3;
    }
  }

  .slide-fade-enter-active {
      transition: all 0.5s ease;
  }

  .slide-fade-enter {
      transition: all 0.5s ease;
  }

  .slide-fade-leave-active {
      transition: all 0.5s ease;
  }

  .slide-fade-leave-to, .slide-fade-enter-from
  {
      transform: translateX(-30px);
      opacity: 0;
  }

  .slide-up-enter-active {
      transition: all 0.4s ease;
  }

  .slide-up-enter {
      transition: all 0.4s ease;
  }

  .slide-up-leave-active {
      transition: all 0.4s ease;
  }

  .slide-up-leave-to, .slide-up-enter-from
  {
      transform: translateY(-20px);
      opacity: 0;
  }

  .slide-down-enter-active {
      transition: all 0.4s ease;
  }

  .slide-down-enter {
      transition: all 0.4s ease;
  }

  .slide-down-leave-active {
      transition: all 0.4s ease;
  }

  .slide-down-leave-to, .slide-down-enter-from
  {
      transform: translateY(20px);
      opacity: 0;
  }

  .transition-group {
    display: flex;
    flex-direction: column;
  }

  .transition-group > * {
    transition-delay: 0.1s;
  }

  .transition-group > *:nth-child(2) {
    transition-delay: 0.2s;
  }

  .transition-group > *:nth-child(3) {
    transition-delay: 0.3s;
  }

  @keyframes bounce {
    25% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.4);
    }
    75% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1.1);
    }
  }
</style>
